import axios from "axios";

/**
 * Central HTTP client. API base comes from env (never hardcoded).
 * All raw server errors are normalized into user-friendly Uzbek messages.
 */
const BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const TOKEN_KEY = "kino_token";

export const http = axios.create({ baseURL: BASE, withCredentials: true, timeout: 15000 });

http.interceptors.request.use((config) => {
  try {
    const t = window.localStorage.getItem(TOKEN_KEY);
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } catch (_) {
    /* storage unavailable */
  }
  return config;
});

export class ApiError extends Error {
  constructor(message, { status = 0, network = false } = {}) {
    super(message);
    this.status = status;
    this.network = network;
  }
}

export const SERVER_DOWN = "Server bilan aloqa o‘rnatilmadi.";

function normalize(err) {
  if (!err.response) return new ApiError(SERVER_DOWN, { network: true });
  const { status, data } = err.response;
  if (status >= 500) return new ApiError(SERVER_DOWN, { status });
  const detail = typeof data?.detail === "string" ? data.detail : "So‘rovda xatolik";
  return new ApiError(detail, { status });
}

export async function request(method, url, { params, data, signal } = {}) {
  try {
    const res = await http.request({ method, url, params, data, signal });
    return res.data;
  } catch (err) {
    if (axios.isCancel(err)) throw err;
    throw normalize(err);
  }
}

export const api = {
  get: (url, opts) => request("get", url, opts),
  post: (url, data, opts = {}) => request("post", url, { ...opts, data }),
  put: (url, data, opts = {}) => request("put", url, { ...opts, data }),
  patch: (url, data, opts = {}) => request("patch", url, { ...opts, data }),
  del: (url, opts) => request("delete", url, opts),
};

export const apiBase = BASE;
